import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';
import MobileHeader from './components/MobileHeader';
import MobileLayout from './components/MobileLayout';
import Typo from '../../atom/Typo';

export interface MobileModalProps {
  visible?: boolean;
  onCancel?: () => void;
  title?: string | ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  backButtonAction?: () => void;
  zIndex?: number;
}
function MobileModal(props: MobileModalProps) {
  const {
    backButtonAction,
    title,
    footer,
    children,
    visible = true,
    onCancel,
    zIndex,
  } = props;
  return (
    <ReactModal
      isOpen={visible}
      closeTimeoutMS={200}
      style={{
        overlay: {
          zIndex,
        },
        content: {
          padding: 0,
          border: 'none',
          inset: 0,
          top: 0,
          left: 0,
          position: 'absolute',
        },
      }}
    >
      <MobileLayout
        header={
          <MobileHeader
            leftActionType="back"
            leftAction={() => {
              if (backButtonAction) backButtonAction();
              else if (onCancel) {
                onCancel();
              }
            }}
          >
            <Typo>{title}</Typo>
          </MobileHeader>
        }
        footer={footer}
      >
        {children}
      </MobileLayout>
    </ReactModal>
  );
}

export default MobileModal;
